import React from 'react'
import { formatInTimeZone } from 'date-fns-tz'
import { Box, Flex, Text } from '@chakra-ui/react'

import {
    ChatFieldsFragment,
    ClientFormFieldsFragment,
} from '~graphql/generated/graphql'
import { getCleanEnum } from '~utils/helpers'
import { UserRoutes } from '~config/routes'
import { navigate } from 'gatsby'

interface Props {
    chat: ChatFieldsFragment
    clientForm: ClientFormFieldsFragment
}

export default function ClientFormItem({ chat, clientForm }: Props) {
    const { clinic } = chat
    const formCompletedDate = formatInTimeZone(
        clientForm.client_completed_at || 0,
        clinic.time_zone || 'America/New_York',
        'PP',
    )

    return (
        <Flex
            rounded="xl"
            flexDir="row"
            alignItems="flex-start"
            justifyContent="space-between"
            w="full"
            cursor="pointer"
            _hover={{ bg: 'gray.50' }}
            p={3}
            onClick={() => {
                navigate(UserRoutes.ViewFormResponse(clientForm.id))
            }}
        >
            <Box>
                <Text fontSize="xs" fontWeight="medium">
                    {clientForm.form?.name}
                </Text>
                {clientForm.form?.form_type && (
                    <Text fontSize="11px" color="gray.500">
                        {getCleanEnum(clientForm.form?.form_type)}
                    </Text>
                )}
            </Box>
            <Flex flexDir="column" alignItems="flex-end">
                <Text fontSize="12px" color="gray.500">
                    Submitted
                </Text>
                <Text fontSize="xs" fontWeight="medium">
                    {formCompletedDate}
                </Text>
            </Flex>
        </Flex>
    )
}
